import * as d3 from 'd3';

const roundPercentage = (number) =>
  Number.isInteger(number) ? number : number.toFixed(2);

export const tooltips = (
  d,
  tooltip,
  width,
  selectedGroupSingular,
  selectedDatasetSingular,
  datasetName,
  percentage,
  summaryCounts
) => {
  tooltip.selectAll('div').remove();

  tooltip
    .append('div')
    .attr('class', 'group text-muted')
    .html(`${selectedGroupSingular}: ${d.values[0].xGroup}`);
  tooltip.append('div').attr('class', 'flex key-value');
  tooltip
    .selectAll('.key-value')
    .append('div')
    .attr('class', 'key')
    .html(
      `${summaryCounts === 1 ? '' : `${selectedDatasetSingular}: `}${datasetName(d.key)}&nbsp;`
    );

  tooltip
    .selectAll('.key-value')
    .append('div')
    .attr('class', 'value')
    .html(
      percentage
        ? `(${roundPercentage(d.values[0].yPercentageValue)}%)`
        : `(${d.values[0].yValue})`
    );

  tooltip
    .style('display', 'flex')
    .style(
      'transform',
      `translate(${d3.event.pageX > width / 2 ? -100 : 0}%, 0)`
    )
    .style('left', `${d3.event.pageX}px`)
    .style('top', `${d3.event.pageY + 8}px`);
};
